module.exports = __webpack_public_path__ + "5c3ccc4aac630cb7799b6cf6a396b488.png";